export const CRUD_PATH = `service`
